export const BREAKPOINT = {
  MOBILE: 1023,
  TABLET: 1024,
  DESKTOP: 1440,
} as const;
